import { Dialog } from '@radix-ui/themes';
import SignIn from './SignIn.jsx';
import styles from './sign_in.module.css';

export const SignInModal = ({ redirectParam }) => {
  return (
    <Dialog.Content
      maxWidth="400px"
      className={styles.dialogContent}
      style={{ padding: '0px' }}
    >
      <SignIn redirectParam={redirectParam} isModal={true} />
    </Dialog.Content>
  );
};
